/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type CoupledBadge_DisplayFragment = { __typename: 'Display', id: string, host?: { __typename: 'Host', coupledState?: string | null, timestamp?: any | null } | null };

export const CoupledBadge_DisplayFragmentDoc = gql`
    fragment CoupledBadge_display on Display {
  id
  host {
    coupledState
    timestamp
  }
}
    `;